module.exports = __webpack_public_path__ + "static/media/delivered-order.96ed0f6c.svg";